(() => {
  const wrapText = (ctx, text, centerX, y, maxWidth, lineHeight) => {
    const chars = Array.from(text || '');
    const lines = [];
    let line = '';
    for (const char of chars) {
      const next = line + char;
      if (ctx.measureText(next).width > maxWidth && line) {
        lines.push(line);
        line = char;
      } else {
        line = next;
      }
    }
    if (line) lines.push(line);
    lines.forEach((value, index) => ctx.fillText(value, centerX, y + index * lineHeight));
    return y + Math.max(0, lines.length - 1) * lineHeight;
  };

  const loadImage = (src) => new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = src;
  });

  const drawRounded = (ctx, x, y, width, height, radius, fill) => {
    ctx.beginPath();
    ctx.roundRect(x, y, width, height, radius);
    ctx.fillStyle = fill;
    ctx.fill();
  };

  const buildImage = async (card) => {
    const canvas = document.createElement('canvas');
    canvas.width = 1080;
    canvas.height = 1350;
    const ctx = canvas.getContext('2d');
    if (!ctx) return null;

    const { title, imageUrl, totalTime, cost, recipeUrl } = card.dataset;
    ctx.fillStyle = '#fff8e9';
    ctx.fillRect(0, 0, 1080, 1350);
    ctx.fillStyle = '#3d4934';
    ctx.fillRect(0, 0, 1080, 30);
    ctx.fillStyle = '#e76f51';
    ctx.fillRect(0, 30, 1080, 12);

    ctx.textAlign = 'center';
    ctx.fillStyle = '#3d4934';
    ctx.font = '900 45px Arial, PingFang SC, Microsoft YaHei, sans-serif';
    ctx.fillText('OKA-OKA · MASAK? BOLEH!', 540, 105);
    ctx.fillStyle = '#746b5c';
    ctx.font = '800 28px Arial, PingFang SC, Microsoft YaHei, sans-serif';
    ctx.fillText('我今晚抽到这道菜', 540, 165);

    let image = null;
    try { image = await loadImage(imageUrl); } catch {}
    ctx.save();
    ctx.beginPath();
    ctx.roundRect(64, 218, 952, 520, 42);
    ctx.clip();
    if (image) {
      const scale = Math.max(952 / image.width, 520 / image.height);
      const width = image.width * scale;
      const height = image.height * scale;
      ctx.drawImage(image, 64 + (952 - width) / 2, 218 + (520 - height) / 2, width, height);
    } else {
      ctx.fillStyle = '#a9b692';
      ctx.fillRect(64, 218, 952, 520);
    }
    const gradient = ctx.createLinearGradient(0, 510, 0, 738);
    gradient.addColorStop(0, 'rgba(39,49,27,0)');
    gradient.addColorStop(1, 'rgba(39,49,27,.82)');
    ctx.fillStyle = gradient;
    ctx.fillRect(64, 510, 952, 228);
    ctx.restore();

    drawRounded(ctx, 88, 244, 238, 58, 29, '#e76f51');
    ctx.fillStyle = '#fffaf0';
    ctx.font = '900 24px Arial, PingFang SC, Microsoft YaHei, sans-serif';
    ctx.fillText('今晚食签', 207, 282);

    ctx.fillStyle = '#fffaf0';
    ctx.font = '900 38px Arial, PingFang SC, Microsoft YaHei, sans-serif';
    wrapText(ctx, title, 540, 654, 810, 52);

    drawRounded(ctx, 72, 812, 936, 230, 32, '#f8d36e');
    ctx.strokeStyle = '#3d4934';
    ctx.lineWidth = 4;
    ctx.stroke();
    ctx.fillStyle = '#3d4934';
    ctx.font = '800 26px Arial, PingFang SC, Microsoft YaHei, sans-serif';
    ctx.fillText('这餐已替你排好', 540, 864);
    ctx.font = '900 42px Arial, PingFang SC, Microsoft YaHei, sans-serif';
    ctx.fillText(totalTime || '做法见完整食谱', 540, 926);
    ctx.fillStyle = '#b9503d';
    ctx.font = '800 31px Arial, PingFang SC, Microsoft YaHei, sans-serif';
    ctx.fillText(cost || '今晚好好吃饭', 540, 978);

    ctx.fillStyle = '#655b46';
    ctx.font = '700 22px Arial, PingFang SC, Microsoft YaHei, sans-serif';
    ctx.fillText('打开 OKA-OKA Masak? Boleh! 看完整材料与做法', 540, 1125);
    ctx.font = '700 18px Arial, sans-serif';
    wrapText(ctx, recipeUrl || '', 540, 1165, 820, 26);
    ctx.fillStyle = '#3d4934';
    ctx.font = '800 23px Arial, PingFang SC, Microsoft YaHei, sans-serif';
    ctx.fillText('OKA-OKA · 好味、好料、好方便', 540, 1282);

    return new Promise((resolve) => canvas.toBlob((blob) => {
      resolve(blob ? new File([blob], `masak-boleh-${title}.png`, { type: 'image/png' }) : null);
    }, 'image/png'));
  };

  const setupCard = (card) => {
    const share = card.querySelector('[data-masak-share]');
    const save = card.querySelector('[data-masak-save]');
    const notice = card.querySelector('[data-masak-notice]');
    const recipeUrl = card.dataset.recipeUrl;
    const report = (message) => { if (notice) notice.textContent = message; };

    const create = async () => {
      report('正在制作你的今晚食签…');
      const file = await buildImage(card);
      if (!file) throw new Error('image');
      return file;
    };

    share?.addEventListener('click', async () => {
      try {
        const file = await create();
        const payload = {
          title: `我今晚抽到：${card.dataset.title}`,
          text: `我今晚抽到「${card.dataset.title}」，你也来拉一下。`,
          url: recipeUrl,
          files: [file]
        };
        if (navigator.share && navigator.canShare?.({ files: [file] })) {
          await navigator.share(payload);
          report('食签已准备好分享');
          return;
        }
        await navigator.clipboard?.writeText(recipeUrl);
        report('已复制食谱链接；也可以保存食签图片后发送');
      } catch (error) {
        if (error?.name !== 'AbortError') report('图片暂时无法生成，可直接复制食谱链接分享');
      }
    });

    save?.addEventListener('click', async () => {
      try {
        const file = await create();
        const link = document.createElement('a');
        link.href = URL.createObjectURL(file);
        link.download = file.name;
        link.click();
        setTimeout(() => URL.revokeObjectURL(link.href), 1000);
        report('今晚食签已保存');
      } catch {
        report('图片暂时无法生成，请稍后再试');
      }
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-masak-article-share]').forEach(setupCard);
  });
})();

